// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

export const useDialogControl = () => {
  const [dialogName, setDialogName] = React.useState('');
  const onCloseDialog = () => {
    setDialogName('');
  };
  return { setDialogName, dialogName, onCloseDialog };
};
